import { render, staticRenderFns } from "./obviateDefectsManage.vue?vue&type=template&id=0c780037&scoped=true&"
import script from "./obviateDefectsManage.vue?vue&type=script&lang=js&"
export * from "./obviateDefectsManage.vue?vue&type=script&lang=js&"
import style0 from "./obviateDefectsManage.vue?vue&type=style&index=0&id=0c780037&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c780037",
  null
  
)

export default component.exports